import { Injectable } from '@angular/core';
import { MingleService } from '@totvs/mingle';
import { Observable } from '@totvs/mingle/node_modules/rxjs';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';

const API_PORTAL = environment.url_portal;

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(private mingleService: MingleService) {}

  post(
    endpoint: string,
    body?: any,
    params?: Object,
    headers?: Object,
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text'
  ) {
    const options: any = {
      params,
      headers,
      responseType,
      body,
    };

    return this.mingleService.gateway.post(
      `${API_PORTAL}/${endpoint}`,
      options
    );
  }

  get(
    endpoint: string,
    options?: Object,
    queryParams?: Object
  ): Observable<any> {
    return this.mingleService.gateway.get(
      `${API_PORTAL}/${endpoint}`,
      options,
      queryParams
    );
  }

  put(
    endpoint: string,
    body?: any,
    params?: Object,
    headers?: Object,
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text'
  ) {
    headers = {
      'Content-Type': 'application/json; charset=utf8'
    };
    const options: any = {
      params,
      headers,
      responseType,
      body,
    };

    return this.mingleService.gateway.put(
      `${API_PORTAL}/${endpoint}`,
      options
    );
  }

  postPasswordRecovery(body: any){
    return this.mingleService.auth.passwordRecovery(body)
  }

  getUrl(url: string) {
    //this.mingleService.gateway.setURLConfig(url);
    //return
  }

}
